import React from "react";
import { styled, useTheme } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";

import MainCard from "../../../components/MainCard";

const StatsCardType = {
  assertion: {
    label1: "Assertions",
    label2: ["Total", "Failed"],
    bgColor: "linear-gradient(135deg, #F3E5F5 0%, #E1BEEF 100%)",
    accent: "#7B1FA2",
    accent2: "#D32F2F"
  },
  preRequestScripts: {
    label1: "Pre-Request Scripts",
    label2: ["Total", "Failed"],
    bgColor: "linear-gradient(135deg, #E8EAF6 0%, #C5CAE9 100%)",
    accent: "#303F9F",
    accent2: "#D32F2F"
  },
  postResponseScripts: {
    label1: "Post-Response Scripts",
    label2: ["Total", "Failed"],
    bgColor: "linear-gradient(135deg, #E0F2F1 0%, #B2DFDB 100%)",
    accent: "#00796B",
    accent2: "#D32F2F"
  },
  avgRespTime: {
    label1: "Avg. Response Time",
    bgColor: "linear-gradient(135deg, #E1F5FE 0%, #B3E5FC 100%)",
    accent: "#0288D1"
  },
  minRespTime: {
    label1: "Min. Response Time",
    bgColor: "linear-gradient(135deg, #E1F5FE 0%, #B3E5FC 100%)",
    accent: "#0288D1"
  },
  maxRespTime: {
    label1: "Max. Response Time",
    bgColor: "linear-gradient(135deg, #E1F5FE 0%, #B3E5FC 100%)",
    accent: "#0288D1"
  },
  respStdDev: {
    label1: "Resp. Time Std. Dev.",
    bgColor: "linear-gradient(135deg, #E1F5FE 0%, #B3E5FC 100%)",
    accent: "#0288D1"
  },
};

const StatsCard = ({ isLoading, cardType, values }) => {
  const theme = useTheme();
  const config = StatsCardType[cardType];

  const CardWrapper = styled(MainCard)(({ theme }) => ({
    overflow: "hidden",
    position: "relative",
    width: "100%",
    background: config.bgColor,
    border: 'none',
    boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    "&:after": {
      content: '""',
      position: "absolute",
      width: "100px",
      height: "100px",
      background: 'rgba(255, 255, 255, 0.25)',
      borderRadius: "50%",
      top: "-30px",
      right: "-30px",
    },
    "&:before": {
      content: '""',
      position: "absolute",
      width: "60px",
      height: "60px",
      background: 'rgba(255, 255, 255, 0.15)',
      borderRadius: "50%",
      bottom: "-15px",
      left: "5%",
    }
  }));

  return (
    <>
      {isLoading ? (
        <CardWrapper>
          <Box sx={{ p: 2.5 }}>
            <Typography variant="h3">Loading...</Typography>
          </Box>
        </CardWrapper>
      ) : (
        <CardWrapper border={false} content={false}>
          <Box sx={{ p: 2.5, height: '100%', position: 'relative', zIndex: 1 }}>
            <Stack spacing={0.5}>
              <Typography
                sx={{
                  color: config.accent,
                  fontWeight: 700,
                  fontSize: '0.8rem',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  opacity: 0.8
                }}>
                {config.label1}
              </Typography>

              {values.length === 1 ? (
                <Typography
                  variant="h1"
                  sx={{
                    color: config.accent,
                    fontWeight: 900,
                    fontSize: '2rem',
                    lineHeight: 1,
                    textShadow: '0 2px 4px rgba(0,0,0,0.05)'
                  }}>
                  {values[0]}<Typography component="span" sx={{ fontSize: '1rem', ml: 0.5 }}>ms</Typography>
                </Typography>
              ) : (
                <Box sx={{ display: "flex", gap: 3, mt: 0.5 }}>
                  <Box>
                    <Typography variant="caption" sx={{ color: config.accent, fontWeight: 600, opacity: 0.7, display: 'block' }}>
                      {config.label2[0]}
                    </Typography>
                    <Typography
                      variant="h2"
                      sx={{
                        color: config.accent,
                        fontWeight: 900,
                        fontSize: '1.6rem',
                        lineHeight: 1
                      }}>
                      {values[0]}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography variant="caption" sx={{ color: config.accent2 || config.accent, fontWeight: 600, opacity: 0.7, display: 'block' }}>
                      {config.label2[1]}
                    </Typography>
                    <Typography
                      variant="h2"
                      sx={{
                        color: config.accent2 || config.accent,
                        fontWeight: 900,
                        fontSize: '1.6rem',
                        lineHeight: 1
                      }}>
                      {values[1]}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Stack>
          </Box>
        </CardWrapper>
      )}
    </>
  );
};

export { StatsCard, StatsCardType };
